/* unplugin-vue-components disabled */import script from "./HomeView3.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView3.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView3.vue?vue&type=style&index=0&id=087abe0d&lang=scss&scoped=true"

import exportComponent from "F:\\hjd\\dev\\yf-dsj\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087abe0d"]])

export default __exports__